const sanitizeQuery = query => (query && query !== 'null' ? query : '');

export default sanitizeQuery;
